<template>
  <div class="select_dialog_embed">
    <div class="store_goods_list_embed_msg"
         :class="{'synchronizationOfInventory' : showType === 'sglSynchronizationOfInventory',
         'w580' : showType === 'batchCloseInventoryDocking',
         'numUpDown' : showType === 'numUpDown'}">
      <div class="select_dialog_embed_box">
        <!--弹出框头部-->
        <div class="select_dialog_embed_box_top">
          <p>{{title}}
            <span v-if="showType === 'setInventoryDocking' || showType === 'batchSetInventoryDocking'" class="fcDel">（配仓优先级不填写默认为0，为0时优先程度最低）</span>
          </p>
        </div>

        <!--弹出框信息-->
        <div class="select_dialog_embed_box_content">
          <!--货品详情-->
          <div v-if="showType === 'goodDetail'" class="select_dialog_embed_box_handle">
            <!--货品详情上部分——包含图片-->
            <div class="good_detail_top">
              <div class="good_detail_top_left clear">
                <table>
                  <tr>
                    <td class="text_right fwb">货号：</td>
                    <td colspan="3" class="text_left">{{goodsData.GoodsId}}</td>
                  </tr>
                  <tr>
                    <td class="text_right fwb">款号：</td>
                    <td colspan="3" class="text_left">{{goodsData.GoodsName}}</td>
                  </tr>
                  <tr>
                    <td class="text_right fwb">零售价：</td>
                    <td class="text_left">{{goodsData.MarketPrice}}</td>
                    <td class="text_right fwb">性别：</td>
                    <td class="text_left">{{goodsData.Gender | gender}}</td>
                  </tr>
                  <tr>
                    <td class="text_right fwb">码段：</td>
                    <td class="text_left">{{goodsData.SGName}}</td>
                    <td class="text_right fwb">分类：</td>
                    <td class="text_left">{{goodsData.ClassName}}</td>
                  </tr>
                  <tr>
                    <td class="text_right fwb">创建时间：</td>
                    <td class="text_left">{{goodsData.CreateTime | time}}</td>
                    <td class="text_right fwb">上市季节：</td>
                    <td class="text_left">{{goodsData.MarketSeasoin}}</td>
                  </tr>
                </table>
              </div>
              <div class="good_detail_top_right clear">
                <img v-if="goodsData.MainImgUrl !== '该商品没有上传主图'" :src="goodsData.MainImgUrl" height="200" width="200"/>
                <img v-if="goodsData.MainImgUrl === '该商品没有上传主图'" :src="null" height="200" width="200"/>
                <!--<a v-if="isShowZip" @click="downloadGoodsImgZipRar()" title="下载货品图片压缩包">下载货品图片压缩包</a>-->
              </div>
            </div>
            <!--货品详情下部分——表格-->
            <div class="good_detail_bottom">
              <!--表格固定头部-->
              <table class="table">
                <colgroup>
                  <col style="width: 100%">
                </colgroup>
                <thead>
                <tr>
                  <th>颜色</th>
                  <th>尺码（[美国码][欧洲码]）</th>
                  <th>商家编码</th>
                  <th>条码</th>
                  <th>重量（g）</th>
                </tr>
                </thead>
              </table>
              <!--表格滚动内容-->
              <table class="table">
                <colgroup>
                  <col style="width: 100%">
                </colgroup>
                <tbody v-if="goodDetail.skuData">
                <tr v-for="(item, index) in goodDetail.skuData" :key="index">
                  <td>{{item.ColorAlias}}</td>
                  <td>{{item.Size}}([{{item.AmericanSize}}][{{item.EuropeSize}}])</td>
                  <td>{{item.BusinessCode}}</td>
                  <td>{{item.BarCode}}</td>
                  <td>{{item.GoodsWeight}}</td>
                </tr>
                </tbody>
                <tbody v-if="!goodDetail.skuData">
                <tr>
                  <td colspan="5">暂时没有相关内容</td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>

          <!--链接详情-->
          <div v-if="showType === 'sglLinkDetail'" class="select_dialog_embed_box_handle">
            <!--链接详情头部模糊搜索-->
            <div class="link_top">
              <div><input type="text" v-model.trim="linkId" placeholder="链接ID"></div>
              <div><input type="text" v-model.trim="linkName" placeholder="名称"></div>
              <button class="btn_normal w116 ml20" @click="getLinkDetailInfoById()">查询</button>
            </div>
            <!--链接详情内容列表-->
            <div class="link_list">
              <!--表格固定头部-->
              <table class="table">
                <colgroup>
                  <col style="width: 100%">
                </colgroup>
                <thead>
                <tr>
                  <th>链接ID</th>
                  <th>名称</th>
                  <th>？上架</th>
                  <th>操作</th>
                </tr>
                </thead>
              </table>
              <!--表格滚动内容-->
              <table class="table">
                <colgroup>
                  <col style="width: 100%">
                </colgroup>
                <tbody v-if="linkList.length">
                <tr v-for="(item, index) in linkList" :key="index">
                  <td>{{item.NumId}}</td>
                  <td>{{item.Title}}</td>
                  <td>{{item.Status | status}}</td>
                  <td><a title="同步库存" @click="ctrBtn(item)">同步库存</a></td>
                </tr>
                </tbody>
                <tbody v-if="!linkList.length">
                <tr><td colspan="4">暂时没有相关内容</td></tr>
                </tbody>
              </table>
            </div>
          </div>

          <!--设置库存对接-->
          <div v-if="showType === 'setInventoryDocking' || showType === 'batchSetInventoryDocking'" class="select_dialog_embed_box_handle">
            <!--列表信息-->
            <div class="inventory_docking_list">
              <table class="table tb_border">
                <colgroup>
                  <col style="width: 100%">
                </colgroup>
                <thead>
                <tr>
                  <th class="bdd-n bdl-l"><input type="checkbox" title="全选" v-model="checkAll" @click="checkOneOrAll()"></th>
                  <th class="bdd-n">渠道名称</th>
                  <th class="bdd-n">配货率</th>
                  <th class="bdd-n">成本价</th>
                  <th class="bdd-n">配仓优先级</th>
                </tr>
                </thead>
              </table>
              <table class="table tb_border">
                <colgroup>
                  <col style="width: 100%">
                </colgroup>
                <tbody v-if="inventoryDockingList.length">
                <tr v-for="(item, index) in inventoryDockingList" :key="index">
                  <td class="bdl-l"><input type="checkbox" title="选择渠道" v-model="item.IsHave" @click="checkOne(index)"></td>
                  <td>{{item.StoreroomName}}</td>
                  <td v-if="item.RealSendRate">{{item.RealSendRate}}%</td>
                  <td v-if="!item.RealSendRate"></td>
                  <td class="bdd-r">{{item.CostPrice}}</td>
                  <td class="bdd-r"><input type="text" title="配仓优先级" v-model.number="item.SetOrderNum"></td>
                </tr>
                </tbody>
                <tbody v-if="!inventoryDockingList.length">
                <tr>
                  <td colspan="6">暂时没有相关信息</td>
                </tr>
                </tbody>
              </table>
            </div>
            <!--关闭货号库存对接-->
            <div class="close_good_num_inventory" v-if="showType !== 'batchSetInventoryDocking'">
              <input type="checkbox" id="closeGoodNumInventory" v-model="isCloseNumInventory" title="关闭货号库存对接">
              <label for="closeGoodNumInventory">关闭货号库存对接（关闭后对应的链接所属货号的SKU将不再同步系统库存）</label>
            </div>
           <!-- <div class="close_good_num_inventory">
              <input type="checkbox" id="closeGoodNumInventory" v-model="isCloseNumInventory" title="店铺成本过滤设置">
              <label for="closeGoodNumInventory">是否使用店铺成本过滤设置</label>
            </div> -->
          </div>

          <!--批量关闭货号库存对接-->
          <div v-if="showType === 'batchCloseInventoryDocking'" class="select_dialog_embed_box_handle text_center pt20 pb15">
            是否关闭选择的货号库存对接？
          </div>

          <!--同步库存-->
          <div v-if="showType === 'sglSynchronizationOfInventory'" class="select_dialog_embed_box_handle">
            请确定是否需要同步此货号的库存？同步完成后对应链接的该货品的库存会进行改变！
          </div>

          <!--货号上下架-->
          <div v-if="showType === 'numUpDown'" class="select_dialog_embed_box_handle">
            <ul>
              <li class="clear"><input type="radio" value="up" v-model="numUpDownVal" id="up" name="upDown"> <label for="up">上架</label></li>
              <li class="clear"><input type="radio" value="down" v-model="numUpDownVal" id="down" name="upDown"> <label for="down">下架</label></li>
            </ul>
          </div>
        </div>

        <!--弹出框底部-->
        <div class="select_dialog_embed_box_bottom">
          <button v-if="showType !== 'goodDetail' && showType !== 'sglLinkDetail'" class="btn_normal" @click="submitBtn()">确定</button>
          <button class="btn_cancel" @click="cancelBtn(false, showType)">关闭</button>
        </div>
      </div>
    </div>

    <!--信息提示框-->
    <msg-dialog v-if="isMsg"
                :txt="txtMsg"
                :is-suc="isSuc"
                :contentType="showType"
                @closebtn="closeMsgDialog"></msg-dialog>

    <!--弹出判断框-->
    <baby-dialog v-if="isShow"
                 :title="dialogTitle"
                 :show-type="showType"
                 :upDownValue="isUpDown"
                 :msg="goodMsg"
                 @cancelmsgbtn="getBabyDialog"></baby-dialog>

    <!--加载框-->
    <loading-dialog v-if="isLoading" :type="loadingType"></loading-dialog>
  </div>
</template>

<script type="es6">
  import MsgDialog from '../../../public-component/msg-dialog';
  import BabyDialog from './baby-dialog';
  import LoadingDialog from '../../../public-component/loading-dialog';

  export default {
    name: 'store-good-list-embed-msg',
    /**
     *  title：  头部名
     *  showType: goodDetail=货品详情信息
     *  goodMsg: 货品信息
     * */
    props: ['title', 'showType', 'goodMsg', 'shopId'],
    components: {MsgDialog, BabyDialog, LoadingDialog},
    data() {
      return {
        goodDetail: '', // 货品详情
        goodsData: '', // 货品信息——不包含SKU
        isShowZip: false, // 是否显示下载压缩包按钮
        linkList: [], // 链接详情内容列表
        linkId: '', // 链接Id
        linkName: '', // 链接名称
        linkDetail: '', // 链接详情
        inventoryDockingList: [], // 设置库存对接的列表
        isCloseNumInventory: true, // 关闭货号库存对接（关闭后对应的链接所属货号的SKU将不再同步系统库存） 1=开启=true，2=关闭=false
        checkAll: false, // 全选
        numUpDownVal: 'up', // 货号上下架值
        isUpDown: false, // 是否上下架
        isShow: '', // 是否显示弹出判断框
        handleType: false, // 弹出判断框的处理类型：true=提交/确定  false=取消
        dialogTitle: '', // 弹出判断框头部
        isMsg: false, // 信息框显示
        isSuc: false, // 是否成功
        txtMsg: '', // 信息框内容
        isLoading: false, // 是否显示加载框
        loadingType: 'NOP', // 加载页面类型
        time: 3, // 倒计时时间
        timer: null // 计时器
      }
    },
    methods: {
      // 获取店铺货品的货品详情
      getGoodsDetail() {
        this.$axios.post(this.Global.getGoodsDetail(this.goodMsg.GoodsId), null).then((res) => {
          if (!res.data.errorMsg.length) {
            console.log(res.data.resData);
            this.goodDetail = res.data.resData;
            this.goodsData = res.data.resData.goodsData;
            if (this.goodDetail.goodsData.ZipImgUrl !== '压缩包地址不存在') {
              this.isShowZip = true;
            } else {
              this.isShowZip = false;
            }
          } else {
            this.isMsg = true;
            this.isSuc = false;
            this.txtMsg = res.data.errorMsg;
          }
        });
      },

      // 获取店铺货品的下载货品图片压缩包
      downloadGoodsImgZipRar() {
        this.$axios.post(this.Global.downloadGoodsImgZipRar(this.goodMsg.GoodsId), null).then((res) => {
          if (!res.data.errorMsg.length) {
            window.open(res.data.resData, '_blank');
          } else {
            this.isMsg = true;
            this.isSuc = false;
            this.txtMsg = res.data.errorMsg;
          }
        });
      },

      // 获取店铺货品的链接详情
      getLinkDetailInfoById() {
        const params = {
          NumId: this.linkId, // 链接Id
          Title: this.linkName // 名称
        };
        this.$axios.post(this.Global.getLinkDetailInfoById(this.goodMsg.GoodsId, this.goodMsg.shopId), params).then((res) => {
          if (!res.data.errorMsg.length) {
            this.linkList = res.data.resData;
          }
        });
      },

      // 加载库存对接列表数据
      loadGoodsStoreroomDatatableList() {
        this.isLoading = true;
        this.$axios.post(this.Global.loadGoodsStoreroomDatatableList(this.goodMsg.GoodsId, this.goodMsg.shopId), null).then((res) => {
          this.isLoading = false;
          if (!res.data.errorMsg.length) {
            this.inventoryDockingList = res.data.resData.resData.storelist;
            if (res.data.resData.resData.CloseStatus === 1) {
              this.isCloseNumInventory = false;
            } else {
              this.isCloseNumInventory = true;
            }
            // 判断是否全选
            let flag = true;
            this.inventoryDockingList.forEach((value) => {
              if (!value.IsHave) {
                flag = false;
                return flag;
              }
            });
            this.checkAll = flag;
          }
        });
      },

      // 获取分销商的渠道信息（ 店铺货品列表、店铺链接列表 批量设置渠道对接适用 ）——获取批量操作的渠道信息入口
      getStoreroomListByShopId() {
        console.log(this.goodMsg);
        this.$axios.post(this.Global.getStoreroomListByShopId(this.goodMsg.shopId), null).then((res) => {
          if (!res.data.errorMsg.length) {
            this.inventoryDockingList = res.data.resData;
          }
        });
      },

      // 设置库存对接
      saveStoreroomGoodsInfo() {
        this.isLoading = true;
        this.loadingType = 'option';
        let status;
        if (this.isCloseNumInventory) {
          status = 2;
        } else {
          status = 1;
        }
        const params = [];
        for (let i = 0; i < this.inventoryDockingList.length; i++) {
          if (this.inventoryDockingList[i].IsHave) {
            params.push({storeroomId: this.inventoryDockingList[i].StoreroomId, setOrderNum: this.inventoryDockingList[i].SetOrderNum});
          }
        }
        this.$axios.post(this.Global.saveStoreroomGoodsInfo(this.goodMsg.GoodsId, this.shopId, status), params).then((res) => {
          this.isLoading = false;
          let timer;
          const self = this;
          timer = setTimeout(function () {
            clearTimeout(timer);
            self.isShow = false;
            if (res) {
              if (!res.data.errorMsg.length) {
                self.cancelBtn(true, self.showType); // 成功后关闭页面
              } else {
                self.isMsg = true;
                self.isSuc = false;
                self.txtMsg = res.data.errorMsg;
              }
            }
          }, 500);
        });
      },

      // 批量 保存货号库存对接的信息
      batchSaveStoreroomGoodsDocking() {
        let checkboxModelLst = [];
        for (let i = 0; i < this.inventoryDockingList.length; i++) {
          if (this.inventoryDockingList[i].IsHave) {
            checkboxModelLst.push({storeroomId: this.inventoryDockingList[i].StoreroomId, setOrderNum: this.inventoryDockingList[i].SetOrderNum});
          }
        }
        const params = {
          shopId: this.goodMsg.shopId,
          goodsIdList: this.goodMsg.checkboxModelLst,
          storeroomOrderNumList: checkboxModelLst
          // storeroomIdList: checkboxModelLst
        };
        this.$axios.post(this.Global.batchSaveStoreroomGoodsDocking, params).then((res) => {
          let timer;
          const self = this;
          timer = setTimeout(function () {
            clearTimeout(timer);
            self.isShow = false;
            if (res) {
              if (!res.data.errorMsg.length) {
                self.cancelBtn(true, self.showType); // 成功后关闭页面
              } else {
                self.isMsg = true;
                self.isSuc = false;
                self.txtMsg = res.data.errorMsg;
              }
            }
          }, 500);
        });
      },

      // 批量 保存货号关闭库存对接信息
      batchCloseGoodsStockDocking() {
        const params = {
          shopId: this.goodMsg.shopId,
          goodsIdList: this.goodMsg.checkboxModelLst
        };
        this.$axios.post(this.Global.batchCloseGoodsStockDocking, params).then((res) => {
          let timer;
          const self = this;
          timer = setTimeout(function () {
            clearTimeout(timer);
            self.isShow = false;
            if (res) {
              if (!res.data.errorMsg.length) {
                self.cancelBtn(true, self.showType); // 成功后关闭页面
              } else {
                self.isMsg = true;
                self.isSuc = false;
                self.txtMsg = res.data.errorMsg;
              }
            }
          }, 500);
        });
      },

      // 店铺货品的同步库存--单个货号同步库存
      synchGoodsStock() {
        this.dialogTitle = '提示';
        this.isShow = true;
        // this.isShow = false;
        this.$axios.post(this.Global.synchGoodsStock(this.shopId, this.goodMsg.GoodsId), null).then((res) => {
          let timer;
          const self = this;
          timer = setTimeout(function () {
            clearTimeout(timer);
            self.isShow = false;
            if (res) {
              if (!res.data.errorMsg.length) {
                self.cancelBtn(true, self.showType); // 成功后关闭页面
              } else {
                self.isMsg = true;
                self.isSuc = false;
                self.txtMsg = res.data.errorMsg;
              }
            }
          }, 500);
        });
      },

      // 单个货号下单个链接同步库存
      synchOneLinkStock() {
        this.$axios.post(this.Global.synchOneLinkStock(this.shopId, this.goodMsg.GoodsId, this.linkDetail.NumId), null).then((res) => {
          console.log(res);
          let timer;
          const self = this;
          timer = setTimeout(function () {
            self.isShow = false;
            clearTimeout(timer);
            if (res) {
              if (!res.data.errorMsg.length) {
                self.cancelBtn(true, self.showType); // 成功后关闭页面
              } else {
                self.isMsg = true;
                self.isSuc = false;
                self.txtMsg = res.data.errorMsg;
              }
            }
          }, 500);
        });
      },

      // 店铺货品的货品上下架
      goodsGoOrDownIng() {
        let type;
        if (this.numUpDownVal === 'up') {
          type = 1;
        } else {
          type = 2;
        }
        this.$axios.post(this.Global.goodsGoOrDownIng(this.shopId, this.goodMsg.GoodsId, type), null).then((res) => {
          console.log(res);
          let timer;
          const self = this;
          timer = setTimeout(function () {
            clearTimeout(timer);
            self.isShow = false;
            if (!res.data.errorMsg.length) {
              self.cancelBtn(true, self.showType); // 成功后关闭页面
            } else {
              self.isMsg = true;
              self.isSuc = false;
              self.txtMsg = res.data.errorMsg;
            }
          }, 500);
        });
      },

      // 单选/全选
      checkOneOrAll() {
        for (let i = 0; i < this.inventoryDockingList.length; i++) {
          this.inventoryDockingList[i].IsHave = !this.checkAll;
        }
      },

      // 单选判断是否全选
      checkOne(i) {
        let flag = true;
        this.inventoryDockingList[i].IsHave = !this.inventoryDockingList[i].IsHave;
        this.inventoryDockingList.forEach((value) => {
          if (!value.IsHave) {
            flag = false;
            return flag;
          }
        });
        this.checkAll = flag;
      },

      // 操作按钮
      ctrBtn(linkDetail) {
        this.linkDetail = linkDetail;
        this.dialogTitle = '提示';
        this.isShow = true;
      },

      // 获取弹出判断框方法返回参数 -- 嵌入弹出框
      getBabyDialog(e) {
        this.isShow = e.showType;
        this.handleType = e.handleType;
        if (this.showType === 'setInventoryDocking' && e.handleType) {
          this.saveStoreroomGoodsInfo();
        } else if (this.showType === 'sglLinkDetail' && e.handleType) {
          this.synchOneLinkStock();
        } else if (this.showType === 'numUpDown' && e.handleType) {
          this.goodsGoOrDownIng();
        } else if (e.handleType) {
          this.cancelBtn(true);
        }
      },

      // 提交按钮
      submitBtn() {
        if (this.showType === 'setInventoryDocking') { // 设置库存对接
          // this.saveStoreroomGoodsInfo();
          this.ctrBtn(null); /* 'setInventoryDocking' */
        } else if (this.showType === 'batchSetInventoryDocking') { // 批量设置库存对接
          this.batchSaveStoreroomGoodsDocking();
        } else if (this.showType === 'batchCloseInventoryDocking') { // 批量关闭设置库存对接
          this.batchCloseGoodsStockDocking();
        } else if (this.showType === 'sglSynchronizationOfInventory') { // 同步库存
          this.synchGoodsStock();
          // this.ctrBtn(); /* 'sglSynchronizationOfInventory' */
        } else if (this.showType === 'sglLinkDetail') { // 单个货号下单个链接同步库存
          this.ctrBtn(this.linkDetail);
          // this.synchOneLinkStock();
        } else if (this.showType === 'numUpDown') {
          if (this.numUpDownVal === 'up') {
            this.isUpDown = '上架';
          } else {
            this.isUpDown = '下架';
          }
          this.ctrBtn(null); /* 'numUpDown' */
        } else {
          this.cancelBtn(false, this.showType);

          // 计时器
          if (this.isMsg) {
            this.time = 3;
            const self = this;
            this.timer = setInterval(function () {
              self.time = --self.time;
              if (self.time < 1) {
                self.isMsg = false;
                clearInterval(self.timer);
              }
            }, 1000);
          }
        }
      },

      // 取消按钮
      cancelBtn(handleType, showType) {
        this.$emit('cancelbtn', {isShow: false, handleType: handleType, showType: showType});
      },

      // 接收提示框传送的数据
      closeMsgDialog(e) {
        this.isMsg = e;
       /* if (this.showType === 'sglSynchronizationOfInventory') {
          this.cancelBtn(true, this.showType);
        } */
      }
    },
    created() {
      if (this.showType === 'goodDetail') {
        this.getGoodsDetail();
      } else if (this.showType === 'sglLinkDetail') {
        this.getLinkDetailInfoById();
      } else if (this.showType === 'setInventoryDocking') {
        this.loadGoodsStoreroomDatatableList();
      } else if (this.showType === 'batchSetInventoryDocking') {
        this.getStoreroomListByShopId();
      }
    }
  }
</script>

<style lang="scss" scoped>
@import "../../../../assets/css/home-view";

.select_dialog_embed {
  .store_goods_list_embed_msg {
    width: 90%;
    min-width: 580px;

    &.w580 {
     width: 580px;
    }

    .select_dialog_embed_box {
      width: 100%;

      .select_dialog_embed_box_handle {
        width: 100%;
        margin-top: 10px;

        /* 货品详情 start */
        .good_detail_top {
          width: 100%;
          height: 200px;

          .good_detail_top_left, .good_detail_top_right {
            display: inline-block;
            float: left;
            height: 100%;
          }

          .good_detail_top_left {
            /*background-color: #13ce66;*/
            width: 55%;

            table {
              width: 70%;
              margin-left: 30px;
              border: none;

              tr {
                border: none;
              }

              th, td {
                border: none;
                padding: 10px 0;
              }
            }
          }

          .good_detail_top_right {
            width: 45%;

            a {
              color: $calink;
              margin-left: 30px;
              position: relative;
              bottom: 15px;

              &:hover {
                cursor: pointer;
              }
            }
          }
        }

        .good_detail_bottom {
          width: 98%;
          margin: 10px auto;
          text-align: center;

          table {
            thead, tbody tr {
              display: table;
              width: 100%;
              table-layout: fixed;
            }

            tbody {
              display: block;
              width: 100%;
              height: 290px;
              overflow-y: auto;
            }
          }
        }
        /* 货品详情 end */

        /* 链接详情 start */
        .link_top {
          &>div {
            display: inline-block;
            width: 30%;
            margin-left: 20px;

            input {
              width: 90%;
            }
          }
        }

        .link_list {
          .table {
            thead, tbody tr {
              display: table;
              width: 100%;
              table-layout: fixed;
            }

            th, td {
              padding: 10px 0;
            }

            tbody {
              display: block;
              width: 100%;
              height: 400px;
              overflow-y: auto;
            }
          }
        }
        /* 链接详情 end */

        /* 设置库存对接 start */
        .inventory_docking_list {
          input[type='checkbox'] {
            width: 20px;
          }

          .table {
            width: 90%;
            margin: 0 auto;

            thead, tbody tr {
              display: table;
              width: 100%;
              table-layout: fixed;
            }

            th, td {
              padding: 10px 0;

              &:first-child {
                width: 80px;
              }
            }

            tbody {
              display: block;
              /*width: 100%;*/
              max-height: 400px;
              /*overflow-y: auto;*/
              overflow-y: scroll;
              width: calc(100% + 1.25em);

              input[type='text'] {
                width: 75px;
              }
            }
          }
        }

        .close_good_num_inventory {
          width: 90%;
          margin: 0 auto;

          input[type='checkbox'] {
            width: 20px;
          }

          label {
            width: calc(100% - 50px);
            text-align: left;
          }
        }
        /* 设置库存对接 end */
      }
    }
  }

  /* 同步库存 start */
  .synchronizationOfInventory {
    width: 62%;
    .select_dialog_embed_box_content {
      .select_dialog_embed_box_handle {
        text-align: center;
        margin-top: 30px;
        margin-bottom: 30px;
      }
    }
  }
  /* 同步库存 end */

  /* 货号上下架 start */
  .numUpDown {
    width: 490px;
    min-width: 490px;

    .select_dialog_embed_box_content {
      .select_dialog_embed_box_handle {
        text-align: center;
        margin-top: 50px;
        margin-bottom: 50px;
        width: 40%;
        height: 40px;

        ul {
          li {
            display: inline-block;
            float: left;

            &:first-child {
              margin-right: 80px;
            }

            input[type='radio']:hover {
              cursor: pointer;
            }
          }
        }
      }
    }
  }
  /* 货号上下架 end */
}
</style>



// WEBPACK FOOTER //
// src/components/home/goods-management/baby-management/store-good-list-embed-msg.vue